import styled, { css } from 'styled-components'
import { Box } from '@mui/material'

export const Container = styled(Box)(
  ({ theme }) => css`
    && {
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      width: 90vw;
      position: absolute;
      height: 90vh;
      align-items: center;
      background-color: ${theme.colors.base.white};
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  `
)

export const Body = styled(Box)(
  ({ theme }) => css`
    && {
      padding: ${theme.layout.padding.small};
      width: 100%;
      align-items: center;
    }
  `
)
